export enum PrimaryNavTabsEnum {
  STOCK = 'stock'
}
